import { organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

// Same-origin by default (the Worker serves this SPA). For a split deployment,
// set VITE_API_BASE to the API origin.
const apiBase = (import.meta.env.VITE_API_BASE ?? "").replace(/\/$/, "");

export const authClient = createAuthClient({
  baseURL: apiBase || undefined,
  basePath: "/api/auth",
  plugins: [organizationClient()],
});

export const { useSession, signIn, signUp, signOut } = authClient;
